import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Autocomplete,
  TextField,
  DialogContentText,
  CircularProgress,
  Box,
} from "@mui/material";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";

export interface BuildingType {
  createdAt: string;
  autoBuildingId: number;
  buildingId: string;
  buildingManagementId: string;
  buildingName: string;
  buildingAddress: string;
  memo: string;
  fulltechOffice: {
    autoFulltechOfficeId: number;
    officeName: string;
  };
  owner:
    | {
        autoOwnerId?: number;
        ownerName?: string;
      }
    | undefined;
}

type BuildingSelectionModalProps = {
  open: boolean;
  onClose: () => void;
  handleSelectBuilding: (building: BuildingType) => void;
};

export const BuildingSelectionModal: React.FC<BuildingSelectionModalProps> = ({
  open,
  onClose,
  handleSelectBuilding,
}) => {
  const [buildings, setBuildings] = useState<BuildingType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // ローディング開始
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();

      if (open) {
        try {
          // call indexBuildings API
          const response = await fetch(
            process.env.REACT_APP_API_ENDPOINT + "/buildings",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: jwtToken,
              },
            }
          );
          const data = await response.json();
          setBuildings(data.buildings);
        } catch (error) {
          console.error("Error fetching buildings:", error);
        } finally {
          setLoading(false); // ローディング終了
        }
      }
    };

    fetchData();
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>物件名選択</DialogTitle>
      <DialogContent>
        <DialogContentText>物件名を選択してください。</DialogContentText>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "150px", // 適切な高さを設定
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Autocomplete
              options={buildings}
              getOptionLabel={(option) => option.buildingName}
              style={{ width: 400 }}
              onChange={(event, newValue) => {
                if (newValue) {
                  handleSelectBuilding(newValue);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="物件名検索" variant="outlined" />
              )}
            />
            <List>
              {buildings.map((building, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleSelectBuilding(building)}
                >
                  <ListItemText>
                    <Typography variant="body1" noWrap>
                      {building.buildingName}
                    </Typography>
                    <Typography variant="body2" noWrap>
                      {building.buildingAddress}
                    </Typography>
                  </ListItemText>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};
